import { FC, ReactNode } from 'react';
import { Container } from './Section.styles';

const Section: FC<{ children: ReactNode }> = ({ children }) => {
	return <Container>{children}</Container>;
};

export default Section;
